export default __webpack_public_path__ + "static/media/iceWarming2.56be9069.png";